import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=050ed9d3&scoped=true&"
import script from "./orderConfirm.js?vue&type=script&lang=js&"
export * from "./orderConfirm.js?vue&type=script&lang=js&"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=050ed9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ed9d3",
  null
  
)

export default component.exports